import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Ignore removeChild errors - they're harmless React/Radix UI conflicts
    if (error?.message?.includes('removeChild')) {
      return { hasError: false };
    }
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Only log non-removeChild errors
    if (!error?.message?.includes('removeChild')) {
      console.error('Error caught by boundary:', error, errorInfo);
      console.error('Error stack:', error.stack);
      console.error('Component stack:', errorInfo.componentStack);
      
      // Store error in session storage for debugging
      try {
        sessionStorage.setItem('lastError', JSON.stringify({
          message: error.message,
          stack: error.stack,
          componentStack: errorInfo.componentStack,
          timestamp: new Date().toISOString()
        }));
      } catch (e) {
        console.error('Could not store error:', e);
      }
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50">
          <div className="text-center p-8">
            <h1 className="text-2xl font-bold text-slate-900 mb-4">
              Algo salió mal
            </h1>
            <p className="text-slate-600 mb-4">
              Por favor, recarga la página
            </p>
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
            >
              Recargar página
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
